import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { STR_BUY_NOW, STR_INTEGRATE_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED, STR_WHATSAPP_BOT_STATUS } from "../Strings";
import { IoMdCloseCircle } from "react-icons/io";
import { MdCheckCircle } from "react-icons/md";

export default function WhatsAppSetupStatus({ }) {
	const appContext = useContext(AppContext);

	/* Place states here */
	async function init() {
		appContext.getCurrentUserData();
	} 

	function view() {
		appContext.navTo({
			item: "view",
			subItem: "whatsapp-setup",
		});
	}

	useEffect(() => {
		init();
	}, [ ])

	return (
		<div
			className="card"

		>
			<div className="card-body text-center">
				<h6
					style={{
						fontSize: "14px"
					}}
					className="mt-4 font-semi-bold text-muted"
				>
					{STR_WHATSAPP_BOT_STATUS[appContext.language]}
				</h6>
				<h6
					style={{
						fontSize: "24px"
					}}
					className="mb-4 font-bold"
				>
					{
						(appContext.currentUserData.whatsAppBotStatus === 'ready' || appContext.currentUserData.whatsAppBotStatus === 'CONNECTED') ?
						<span
							className="text-secondary"
						>
							<MdCheckCircle size={48}/>
							<br/>
							{appContext.currentUserData.whatsAppBotStatus}
						</span>
						:
						<span
							className="text-danger"
						>
							<IoMdCloseCircle size={48}/>
							<br/>
							{appContext.currentUserData.whatsAppBotStatus}
						</span>
					}
				</h6>

				{
					(appContext.currentUserData.whatsAppBotStatus !== 'ready' && appContext.currentUserData.whatsAppBotStatus !== 'CONNECTED') ?
					<button
						className="btn btn-rounded btn-padded btn-secondary mt-4 mb-4"
						onClick={view}
					>
						{STR_INTEGRATE_NOW[appContext.language]}
					</button>
					:""
				}

				
			</div>
			
		</div>
	);
}
